const rail = {
  rails: "Ράγες", // translated
  senior: "Αρχαιότερος", // translated
  seniors: "Ηλικιωμένοι", // translated
  youths: "Νεαροί", // translated
  yearOld: "ετών", // translated
  yearsOld: "χρονών", // translated
};


export default rail;
